<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">upload_file</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Importar nota fiscal por XML</h2>
    <span class="modal-subtitle">Selecione um arquivo e siga as etapas para concluir a importação</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<app-wizard-steps
  [passos]="passos"
  [passoAtual]="passoAtual"
  [flush]="true"
  [clicavel]="true"
  [exibirAlerta]="false"
  (passoSelecionado)="onPassoSelecionado($event)">
</app-wizard-steps>

<mat-dialog-content class="modal-content">

  @if (fase !== FaseAssistenteEnum.Arquivo) {
  <app-alert-card type="info" icon="description" class="importar-xml-documento-alerta">
    <div class="importar-xml-documento-alerta-corpo">
      <strong>{{ arquivo?.nome }}</strong>
      <span>{{ descricaoDocumento || 'Arquivo XML selecionado para validação.' }}</span>
    </div>
  </app-alert-card>
  }

  @if (fase === FaseAssistenteEnum.Arquivo) {
  <app-importar-xml-arquivo-step
    [arquivo]="arquivo"
    (arquivoSelecionado)="onArquivoSelecionado($event)">
  </app-importar-xml-arquivo-step>
  }

  @if (fase === FaseAssistenteEnum.Validacao) {
  <app-importar-xml-validacao-step
    [validacoes]="validacoes"
    [isProcessando]="isProcessando"
    [isErro]="isErro"
    [validacaoComErro]="validacaoComErro"
    [mensagemErroGeral]="arquivo?.mensagem">
  </app-importar-xml-validacao-step>
  }

  @if (fase === FaseAssistenteEnum.Natureza) {
  <app-importar-xml-natureza-step
    [descricaoNaturezaOperacaoXml]="descricaoNaturezaOperacaoXml"
    [listaNaturezaOperacao]="listaNaturezaOperacao"
    [(idNaturezaOperacaoSistema)]="idNaturezaOperacaoSistema">
  </app-importar-xml-natureza-step>
  }

  @if (fase === FaseAssistenteEnum.Regras) {
  <app-importar-xml-regras-step
    [regras]="regras"
    [(consideraApenasDescricao)]="consideraApenasDescricao"
    (moverRegra)="moverRegra($event.indice, $event.direcao)"
    (restaurarPadrao)="restaurarRegrasPadrao()">
  </app-importar-xml-regras-step>
  }

</mat-dialog-content>

<div class="modal-footer">
  <div class="importar-xml-footer-acoes-esquerda">
    <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isProcessando || isSalvandoRascunho" (click)="fechar()">Cancelar</button>
  </div>

  <div class="importar-xml-footer-acoes-direita">
    @if (fase === FaseAssistenteEnum.Validacao) {
    <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isProcessando" (click)="voltarParaArquivo()">Voltar</button>
    @if (idNotaExistente && data.origem === OrigemImportacaoXmlNFeEntradaEnum.CentralNotas) {
    <button mat-stroked-button type="button" class="btn-secondary" (click)="irParaNotaExistente()">
      Ir para a nota
    </button>
    @if (isAssociacaoPendente) {
    <button mat-flat-button type="button" class="btn-primary" (click)="associarItensNotaExistente()">
      Associar itens
    </button>
    }
    }
    }
    @if (fase === FaseAssistenteEnum.Natureza) {
    <button mat-stroked-button type="button" class="btn-secondary" (click)="voltarParaValidacao()">Voltar</button>
    }
    @if (fase === FaseAssistenteEnum.Regras) {
    <button mat-stroked-button type="button" class="btn-secondary" (click)="voltarParaNatureza()">Voltar</button>
    }
    @if (fase === FaseAssistenteEnum.Arquivo) {
    <button mat-flat-button type="button" class="btn-primary" [disabled]="!temArquivo" (click)="avancarParaValidacao()">Avançar</button>
    }
    @if (fase === FaseAssistenteEnum.Validacao) {
    <button mat-flat-button type="button" class="btn-primary" [disabled]="!isSucesso" (click)="avancarParaNatureza()">Avançar</button>
    }
    @if (fase === FaseAssistenteEnum.Natureza) {
    <button mat-flat-button type="button" class="btn-primary"
      [disabled]="!idNaturezaOperacaoSistema"
      (click)="avancarParaRegras()">Avançar</button>
    }
    @if (fase === FaseAssistenteEnum.Regras) {
    <button mat-flat-button type="button" class="btn-primary importar-xml-botao-iniciar btn-spinner" [class.btn-loading]="isSalvandoRascunho"
      [disabled]="isSalvandoRascunho" [attr.aria-label]="isSalvandoRascunho ? 'Iniciando lançamento' : 'Iniciar lançamento'"
      (click)="salvarRascunho()">
      Iniciar lançamento
      @if (isSalvandoRascunho) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
    }
  </div>
</div>
